(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');

    // click-directive to switch user-view 
    module.directive('quickSidebarSwitchTask', ['AgendaTransitionService', 'QuickSidebarTasksService', function (AgendaTransitionService, QuickSidebarTasksService) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                id: '@' // daytask id
            }
        };
        return directive;

        function link(scope, element) {

            // click listener
            element.on('click', function () {
                switching();
            });

            // switching/changing agenda
            function switching() {
                // find task by id 
                var task = QuickSidebarTasksService.findById(parseInt(scope.id));
                if (task === null) { return; }
                QuickSidebarTasksService.data.current = task;
                // switch to agenda
                AgendaTransitionService.change(task.agendaOwnerId, task.switchDate);
            } // show

            // on destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });

        }
    }]);

})();